<template>
  <div class="home-newsletter-modal">
    <button class="btn-close" @click="$emit('close')">
      <i class="icon-x"></i>
    </button>
    <div
      v-if="news.cover"
      class="news-image"
      :style="`background-image: url(${news.cover})`"
    />
    <div class="flex-fill p-3">
      <h4 class="mb-5 pr-5">{{ news.title }}</h4>
      <div class="description" v-html="news.description" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    news: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.home-newsletter-modal {
  position: relative;
  display: flex;

  .btn-close {
    background: transparent;
    border: none;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 32px;
    color: white;
  }

  .news-image {
    min-width: 40%;
    min-height: 100%;
    background-size: cover;
    background-position: center center;
    margin-right: 24px;
  }

  .description {
    ::v-deep * {
      background: none !important;
      color: #f8f9fa !important;
    }
  }
}
</style>
